'use client'

import './NotifyContainer.css'

import Notify from '@/components/ui/Notify'

import { useAppSelector, useAppStore } from '@/lib/hook'
import { type NotifyType, notifyContainerActions } from '@/lib/store'

export function notify(type: NotifyType, message: string) {
    const store = useAppStore()
    store.dispatch(notifyContainerActions.addNotification({ type, message }))
}

export default function NotifyContainer() {
    const notifications = useAppSelector(state => state.notifyContainer.notifications)

    return (
        <div className='notify-container'>
            {notifications.map((notification, index) => (
                <Notify key={notification.id ?? index} type={notification.type} message={notification.message} id={notification.id} />
            ))}
        </div>
    )
}